// Golf 8 (0049; docs/onderzoek/golf8-samenwonen-en-ouderen.md §2.2, §2.9 en §2.10): de webapp van
// Samen wonen (appText.samen): Wie eet mee, Kosten delen, Reserveren, de Vandaag-widgets en het
// inrichten van het huis. Toon: je-vorm, nuchter en volwassen. Nooit: sterren, "Goed gedaan!",
// dieren, confetti, "klusjes", "punten", "schuld" of "moet betalen aan". Een vraag bij een uitgave
// heet "Klopt dit niet?". Meervouden zonder meervoudsvormen ("Eters: 5"), zodat elke taal klopt.
export const appSamenNl = {
    /** Woorden per soort (§2.9). */
    words: {
        dinnerTitle: 'Wie eet mee?',
        dinnerTitleCohousing: 'Gezamenlijke maaltijd',
        costsTitle: 'Kosten delen',
        costsTitleCohousing: 'Gezamenlijke kosten',
        costsTitleCouple: 'Samen betalen',
        costsTitleTwoHome: 'Kosten voor de kinderen',
        emptyStudent: "Nog niemand. Wordt het tosti's?",
        emptyShared: 'Nog niemand aangemeld.',
        emptyCohousing: 'Nog geen aanmeldingen.',
        formerShared: 'Voormalig huisgenoot',
        formerCohousing: 'Oud-bewoner',
        formerFamily: 'Voormalig gezinslid',
    },
    nav: {
        dinner: 'Wie eet mee',
        dinnerCohousing: 'Samen eten',
        bookings: 'Reserveren',
        costs: 'Kosten',
    },
    common: {
        save: 'Opslaan',
        cancel: 'Annuleren',
        close: 'Sluiten',
        saved: 'Opgeslagen',
        you: 'jij',
        left: '(vertrokken)',
        undo: 'Oeps',
        moreActions: 'Meer',
    },
    dinner: {
        intro: 'Wie er vanavond mee-eet, wie kookt en tot hoe laat je je aanmeldt.',
        emptyTitle: 'Samen eten?',
        emptyBody: 'Kies een deadline en wie er kookt.',
        start: 'Start de eetlijst',
        started: 'De eetlijst staat klaar.',
        tonight: 'Vanavond',
        headCook: 'kok {name}',
        headNoCook: 'nog geen kok',
        eaters: 'Eters: {n}',
        guestsExtra: '(+{n} gast)',
        until: 'Aanmelden tot {time} (nog {left})',
        closed: 'Aanmelden gesloten. Vraag het {name}.',
        closedNoCook: 'Aanmelden gesloten.',
        openForYou: 'De deadline is voorbij, maar jij kunt de lijst nog aanpassen.',
        noDinner: 'Vandaag geen huisdiner',
        notDinnerDay: 'Op deze dag is er geen huisdiner.',
        myChoice: 'Mijn keuze',
        imIn: 'Ik eet mee',
        imOut: 'Niet',
        noChoice: '—',
        guests: 'Gasten',
        guestsHint: 'Alleen het aantal; geen namen.',
        groupIn: 'Eet mee',
        groupOut: 'Eet niet mee',
        groupUnknown: 'Nog niet gekozen',
        sourceDefault: 'standaard',
        sourceHouse: 'standaard van het huis',
        sourceAway: 'weg',
        sourceBoard: 'via het bord',
        sourceBy: 'gezet door {name}',
        sourceCook: 'kookt',
        setFor: 'Voor {name}',
        cookTitle: 'Kok',
        cookClaim: 'Ik kook',
        cookOther: 'Iemand anders kookt',
        cookRotation: 'Terug naar het rooster',
        cookPick: 'Wie kookt er?',
        cookFromRotation: 'volgens het rooster',
        noDinnerSet: 'Vandaag geen huisdiner',
        noDinnerUndo: 'Toch huisdiner',
        note: 'Notitie van de kok',
        noteHint: 'Iedereen in huis ziet dit, maar niet op het bord.',
        meal: 'Op het menu: {title}',
        groceries: 'Boodschappen invoeren',
        listChanged: 'Eetlijst gewijzigd · Opnieuw verdelen',
        settings: 'Instellingen eetlijst',
        cutoff: 'Aanmelden tot',
        cutoffHint: 'Tussen 10:00 en 21:00.',
        days: 'Dagen met huisdiner',
        houseDefault: 'Wie nog niets koos',
        houseDefaultUnknown: 'Vragen',
        houseDefaultIn: 'Eet mee',
        houseDefaultOut: 'Eet niet mee',
        remind: 'Herinnering vóór de deadline',
        remindOff: 'Uit',
        remindMinutes: '{n} min',
        remindHours: '{n} uur',
        cookItem: 'Kookklus uit het rooster',
        cookItemNone: 'Geen (zelf claimen)',
        myDefault: 'Mijn standaard',
        myDefaultHint: 'Per weekdag. Een eigen keuze op een dag gaat altijd voor.',
        prefIn: 'Mee',
        prefOut: 'Niet',
        prefAsk: 'Vraag het me',
        signedIn: '{name} eet mee',
        signedOut: '{name} eet niet mee',
        cleared: 'Keuze weggehaald',
        closedToast: 'Aanmelden is gesloten.',
        widgetAll: 'Naar de eetlijst',
        widgetNotYet: 'Je hebt nog niet gekozen.',
        widgetYouIn: 'Jij eet mee',
        widgetYouOut: 'Jij eet niet mee',
    },
    costs: {
        visibleAll: 'Alle huisgenoten zien uitgaven en saldi. Er gaat geen geld via AMUMIN.',
        visibleTwoHome: 'Alleen de ouders zien dit. Kinderen zien niets. Er gaat geen geld via AMUMIN. Op het bord komt alleen iets als je dat zelf per tablet uitdrukkelijk bevestigt; dat kun je altijd weer weghalen.',
        tabExpenses: 'Uitgaven',
        tabBalance: 'Saldo',
        tabSettled: 'Verrekend',
        add: 'Uitgave',
        empty: 'Nog geen uitgaven.',
        emptyBody: 'Voer een uitgave in; AMUMIN rekent uit wie wat krijgt.',
        rowPaid: 'betaald door {name}',
        rowFor: 'voor {n}',
        new: 'nieuw',
        edited: 'bewerkt',
        questionBadge: 'vraag open',
        locked: 'afgesloten',
        loadMore: 'Meer laden',
        deletedList: 'Verwijderd ({n})',
        deletedHint: 'Nog 30 dagen terug te zetten.',
        newTitle: 'Nieuwe uitgave',
        editTitle: 'Uitgave wijzigen',
        amount: 'Bedrag',
        amountHint: 'Bijvoorbeeld 12,50',
        amountInvalid: 'Vul een bedrag in, bijvoorbeeld 12,50.',
        amountTooLarge: 'Dat bedrag is te hoog.',
        ambiguous: 'Bedoel je {a} of {b}?',
        confirmLarge: 'Klopt {amount}?',
        confirmLargeYes: 'Ja, klopt',
        description: 'Omschrijving',
        descriptionHint: 'Iedereen in huis ziet dit',
        paidBy: 'Betaald door',
        date: 'Datum',
        dateFuture: 'Een datum in de toekomst kan niet.',
        dateLocked: 'Die periode is afgesloten (t/m {date}).',
        split: 'Verdeling',
        splitEqual: 'Gelijk',
        splitWeights: 'Naar verhouding',
        splitExact: 'Precies',
        splitDinner: 'Eters van {date}',
        splitDinnerHint: 'Verdeeld over wie er mee-at; gasten tellen bij wie ze meenam.',
        remaining: 'nog {amount} te verdelen',
        tooMuch: '{amount} te veel',
        perPerson: 'Per persoon',
        nobody: 'Kies minstens één persoon.',
        enteredBy: 'ingevoerd door {name}',
        editedBy: 'bewerkt door {name} op {date}',
        edit: 'Wijzigen',
        delete: 'Verwijderen',
        deleteConfirm: 'Weet je het zeker?',
        deleteBody: 'Je kunt hem nog 30 dagen terugzetten.',
        deleted: 'Verwijderd',
        restore: 'Terugzetten',
        restored: 'Teruggezet',
        question: 'Klopt dit niet?',
        questionAsked: 'Je vraag staat bij de uitgave.',
        questionOpen: '{name} vraagt of dit klopt',
        questionResolve: 'Klopt wel',
        questionAdjust: 'Aanpassen',
        questionWithdraw: 'Vraag intrekken',
        detailTitle: 'Uitgave',
        lockedNote: 'Deze uitgave valt in een afgesloten periode.',
        gets: 'krijgt nog {amount}',
        owes: 'moet nog {amount} verrekenen',
        even: 'staat op nul',
        twoHomeOpen: 'nog te verrekenen: {amount}',
        suggestions: 'Voorstel om te verrekenen',
        suggestionLine: '{from} → {to} {amount}',
        copy: 'Kopieer tekst',
        copied: 'Gekopieerd',
        iPaid: 'Ik heb betaald',
        wasPaid: 'Is betaald',
        settleTitle: 'Verrekening',
        settleHint: 'Er gaat geen geld via AMUMIN; dit is alleen een notitie.',
        settleSaved: 'Genoteerd. {name} bevestigt het nog.',
        settleSavedConfirmed: 'Genoteerd.',
        pending: 'Wachtende verrekeningen',
        pendingLine: '{from} meldt {amount} betaald',
        confirm: 'Klopt',
        reject: 'Klopt niet',
        waiting: 'wacht op {name}',
        confirmed: 'bevestigd',
        unconfirmed: 'niet bevestigd',
        noLogins: '{names} hebben nog geen eigen login. Tot ze hun uitnodiging aannemen, beheer jij hun uitgaven en telt een verrekening aan hen meteen (niet bevestigd).',
        noLoginsOne: '{names} heeft nog geen eigen login. Tot die de uitnodiging aanneemt, beheer jij de uitgaven en telt een verrekening meteen (niet bevestigd).',
        inviteHousemates: 'Huisgenoten uitnodigen',
        removeSettlement: 'Weghalen',
        carried: 'Overgenomen saldo',
        closeTitle: 'Periode afsluiten',
        closeBody: 'Afsluiten t/m {date}.',
        closeHelp: 'Open saldi gaan mee. Oudere regels worden vergrendeld en 24 maanden na hun datum gewist.',
        closeButton: 'Afsluiten t/m {date}',
        closeQuestions: 'Eerst de open vragen beantwoorden ({n}).',
        closePending: 'Eerst de wachtende verrekeningen ({n}).',
        closeNothing: 'Er is nog niets af te sluiten.',
        closed: 'Afgesloten t/m {date}',
        lastClosed: 'Laatst afgesloten t/m {date}',
        allSettled: 'Alles verrekend',
        exportCsv: 'Exporteer CSV',
        settledEmpty: 'Nog geen verrekeningen.',
        leaverWarn: '{name} heeft nog {amount} open.',
        leaverHint: 'Verreken dit eerst, of spreek het samen af. Het saldo blijft in het overzicht.',
        offWarn: 'Kosten delen gaat uit. De gegevens blijven 12 maanden bewaard en worden daarna gewist.',
        widgetGets: 'Jij krijgt nog {amount}',
        widgetOwes: 'Jij moet nog {amount} verrekenen',
        widgetEven: 'Alles verrekend',
        widgetAll: 'Naar de kosten',
        twoHomeConfirm: 'Werkt als jullie allebei ouder zijn in dit huishouden. Kinderen zien niets.',
        twoHomeConfirmYes: 'Aanzetten',
    },
    bookings: {
        intro: 'Wasmachine, droger, ruimte of logeerbed: zie wie wanneer aan de beurt is.',
        empty: 'Nog niets om te reserveren.',
        emptyBody: 'Kies wat jullie delen. De standaardregels kun je later aanpassen.',
        addKind: '+ {name}',
        day: 'Dag',
        prevDay: 'Vorige dag',
        nextDay: 'Volgende dag',
        today: 'Vandaag',
        free: 'vrij',
        mine: 'jij',
        closedHours: 'gesloten',
        dstHour: 'klokwissel',
        tapFree: 'Tik op een vrije tijd om te reserveren.',
        sheetTitle: '{resource} reserveren',
        start: 'Begint om',
        duration: 'Hoe lang',
        forWho: 'Voor wie',
        book: 'Reserveer',
        booked: '{resource} {time} gereserveerd',
        fromDate: 'Van',
        toDate: 'Tot en met',
        maxNights: 'Hooguit {n} nachten achter elkaar.',
        overlap: 'Om {time} is {name} al aan de beurt. Eerstvolgende vrije tijd: {next}.',
        overlapNoNext: 'Die tijd is al gereserveerd.',
        takeNext: 'Neem {time}',
        err: {
            past: 'Die tijd is al voorbij.',
            max_days_ahead: 'Reserveren kan tot {n} dagen vooruit.',
            slot: 'Kies een tijd op het rooster van {n} minuten.',
            dst_hour: 'Die tijd valt in het uur van de klokwissel. Kies een andere tijd.',
            max_minutes: 'Maximaal {duration} achter elkaar.',
            closed_hours: 'De {resource} kan van {from} tot {until}.',
            quota: 'Je hebt deze week al {n} reserveringen voor de {resource}.',
            max_days: 'Hooguit {n} dagen achter elkaar.',
        },
        myTitle: 'Mijn reserveringen',
        myEmpty: 'Je hebt niets gereserveerd.',
        cancel: 'Annuleren',
        cancelled: 'Geannuleerd',
        done: 'Klaar, maak vrij',
        freed: 'Weer vrij',
        viaBoard: 'via het bord',
        cancelledBoard: 'geannuleerd via het bord, {time}',
        manage: 'Beheren',
        manageTitle: 'Dingen om te reserveren',
        addThing: 'Ding toevoegen',
        editThing: '{name} aanpassen',
        name: 'Naam',
        kind: 'Soort',
        unit: 'Reserveren per',
        unitSlot: 'tijdvak',
        unitDay: 'hele dag',
        slotMinutes: 'Tijdvak',
        defaultMinutes: 'Standaardduur',
        maxMinutes: 'Hooguit achter elkaar',
        maxDays: 'Hooguit dagen achter elkaar',
        maxAhead: 'Vooruit reserveren (dagen)',
        perWeek: 'Per persoon per week',
        perWeekNone: 'Geen grens',
        openFrom: 'Open van',
        openUntil: 'Open tot',
        alwaysOpen: 'Altijd open',
        onBoard: 'Op het bord in de gang',
        archive: 'Archiveren',
        unarchive: 'Terugzetten',
        archived: 'Gearchiveerd',
        minutes: '{n} min',
        hours: '{n} uur',
        widgetNext: 'Jij: {resource} {time}',
        widgetFreeNow: '{resource}: nu vrij',
        widgetBusyUntil: '{resource}: bezet tot {time}',
        widgetAll: 'Naar reserveren',
        kinds: {
            washer: 'Wasmachine',
            dryer: 'Droger',
            room: 'Ruimte',
            guest_bed: 'Logeerbed',
            other: 'Anders',
        },
    },
    setup: {
        residents: 'Met hoeveel zijn jullie?',
        residentsLess: 'Minder',
        residentsMore: 'Meer',
        shares: 'Wat delen jullie?',
        shareNames: {
            kitchen: 'Keuken',
            bathroom: 'Badkamer',
            laundry: 'Wasmachine',
            dryer: 'Droger',
            common_room: 'Gemeenschappelijke ruimte',
            guest_bed: 'Logeerbed',
            groceries: 'Boodschappen',
            costs: 'Kosten',
        },
        sameRights: 'Huisgenoten krijgen dezelfde rechten als jij.',
        housemates: 'Huisgenoten',
        housematesHint: 'Hun namen, dan staan ze meteen in het rooster en op de eetlijst.',
        housemateName: 'Naam huisgenoot {n}',
        housematesAdd: 'Voeg huisgenoten toe',
        housematesAdded: 'Huisgenoten toegevoegd: {n}',
        housemateEmail: 'E-mail van huisgenoot {n} (niet verplicht)',
        invitesSent: 'Uitnodigingen verstuurd: {n}',
        invitesLater: 'Nog niet uitgenodigd. Dat kan later bij Huisgenoten.',
        oneByOne: 'Of één persoon apart (bijvoorbeeld een kind of een oppas)',
        planTitle: 'Zo richten we het huis in',
        planBody: 'Dit komt erbij. Er gaat nooit iets weg; wat er al is, blijft zoals het is.',
        planRooms: 'Kamers: {list}',
        planDuties: 'Rooster: {list}',
        planResources: 'Reserveren: {list}',
        planDinner: 'Eetlijst: aanmelden tot {time}',
        run: 'Richt het huis in',
        again: 'Opnieuw inrichten',
        againHint: 'Voegt alleen toe wat er nog niet is. Er gaat niets weg.',
        doneToast: 'Het huis is ingericht.',
        nothingNew: 'Alles stond er al.',
        offTitle: 'Er gaat een module met gegevens uit',
        offDinner: 'Wie eet mee gaat uit. De gegevens blijven 12 maanden bewaard en worden daarna gewist.',
        offBookings: 'Reserveren gaat uit. De gegevens blijven 12 maanden bewaard en worden daarna gewist.',
        csv: 'Download de kosten als CSV',
    },
    push: {
        dinner: 'Wie eet mee',
        dinnerHint: '"Eet je mee?" vóór de deadline, en de kok hoort wie er komt.',
        bookings: 'Reserveren',
        bookingsHint: 'Je reservering begint zo, of iemand annuleerde op het bord.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: '{name} uitnodigen',
        body: '{name} krijgt een e-mail met een link en kiest zelf een wachtwoord. Huisgenoten krijgen dezelfde rechten als jij.',
        email: 'E-mailadres',
        send: 'Uitnodiging versturen',
        sent: 'Uitnodiging verstuurd naar {email}',
        pending: 'Uitgenodigd: {email}',
        resend: 'Opnieuw sturen',
        taken: 'Deze persoon heeft al een eigen login.',
        already: 'Dit adres hoort al bij dit huis.',
        limit: 'Vandaag zijn er al 20 uitnodigingen verstuurd. Probeer het morgen opnieuw.',
        inUse: 'Dit adres heeft al een uitnodiging om mee te kijken. Trek die eerst in.',
        loginNew: 'Log in met je nieuwe wachtwoord. Je e-mailadres staat al ingevuld.',
        hint: 'Nog zonder eigen login: {names}. Tik op een naam om die persoon per e-mail uit te nodigen.',
        landingTitle: 'Uitnodiging voor je huis',
        landingBody: '{inviter} nodigt je uit voor {household}. Je staat erin als {member}.',
        accepted: 'Welkom in {household}. Je kunt nu de app gebruiken.',
    },
};
//# sourceMappingURL=samenApp.nl.js.map